<template>
  <form class="container-fluid">
    <div class="device_serial">
      <div class="row">
        <!-- Choose a Device ID -->
        <div class="col-12">
          <label style="color:#0892D0;" for="deviceId"
            >Choose a Device ID
          </label>
          <select
            name="deviceId"
            id="deviceId"
            v-model="regparams.deviceId"
            placeholder="Select a DeviceId"
            class="form-control"
            required
          >
            <option value="" disabled selected hidden>Select a DeviceId</option>
            <option value="41148428">41148428</option>
            <option value="41148430">41148430</option>
            <option value="416811">416811</option>
          </select>
        </div>
      </div>
      <!-- Pick one or more Serial Number -->
      <div class="row mul_select">
        <div class="col-12 multiple_option">
          <label style="color:#0892D0;" for="lux_serial_number"
            >Pick one or more Lux Serial Number</label
          >
          <select
            name="lux_serial_number"
            id="lux_serial_number"
            v-model="regparams.serialNumbers"
            multiple
            size="2"
            class="form-control"
          >
            <option value="2480530042">2480530042</option>
            <option value="2480530073">2480530073</option>
            <option value="2480530057">2480530057</option>
            <option value="ARN-416774">ARN-416774</option>
            <option value="ARN-416775">ARN-416775</option>
            <option value="ARN-416776">ARN-416776</option>
            <option value="ARN-416777">ARN-416777</option>
            <option value="ARN-416778">ARN-416778</option>
            <option value="ARN-416779">ARN-416779</option>
            <option value="ARN-416770">ARN-416770</option>
            <option value="ARN-4167712">ARN-4167712</option>
          </select>
        </div>
      </div>
      <!-- Button -->
      <div class="container-fluid">
        <div class="button_style">
          <button
            type="submit"
            class="btn btn-outline-primary btn-lg"
            @click="back"
          >
            Back
          </button>
          <button type="button" class="btn btn-primary btn-lg" @click="submit">
            Next
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { isEmpty } from "element-ui/src/utils/util";
export default {
  name: "DeviceSerial",
  data() {
    return {
      regparams: {
        deviceId: "",
        serialNumbers: []
      },
      errorsResult: {},
      validateError: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg() {
      let errors = [];
      for (let [field, value] of Object.entries(this.regparams)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "deviceId":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "DeviceID cannot be empty.";
            }
            break;
          case "serialNumbers":
            if (value === [] || value === NaN || isEmpty(value)) {
              errors[field] = "Serial Number cannot be empty.";
            }
            break;
          default:
            break;
        }
        this.errorsResult = errors;
      }
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        this.validateError = true;
        setTimeout(() => {
          this.displayError == false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      } else {
        this.validateError = false;
      }
    },
    async dataPassage() {},
    submit() {
      this.validateReg();
      const LuxOnboardingStatus = this.$store.state.luxOnboardingStatus;
      if (this.validateError === false) {
        LuxOnboardingStatus.deviceId = this.regparams.deviceId;
        LuxOnboardingStatus.serialNumbers = this.regparams.serialNumbers;
        this.$store.state.luxCount = 2;
      } else {
        console.log("Validate data first");
      }
    },
    back() {
      window.history.back();
    }
  }
};
</script>

<style scoped>
.device_serial {
  font-family: sans-serif;
}
.button_style {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 80%;
  font-family: sans-serif;
  width: 100%;
  margin: auto;
  padding: 24px 0;
}
.device_serial select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.device_serial label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.multiple_option select {
  height: 120px !important;
}

.lux_payment {
  font-family: sans-serif;
  width: 90%;
  max-width: 654px;
  padding-top: 18px;
}
.lux_payment label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.lux_payment select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.lux_payment input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.luxMisc {
  font-family: sans-serif;
  width: 90%;
  max-width: 654px;
  padding-top: 18px;
}
.luxMisc label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.luxMisc input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/DeviceSerial.vue